module.exports = __webpack_public_path__ + "img/badge-isi2025.68280d2.jpg";